module.exports = __webpack_public_path__ + "static/media/heroimage_igib-004.d6c9e4b9.jpg";